import { NAVEGA } from "../constants/actions-types";

const default_navegacion ={
	pagina:"inicio",
};

function navegaReducer(state = default_navegacion,action){
	if(action.type === NAVEGA){
		let newState = {...state};
		newState.pagina = action.pagina;
		return newState;
	}
	return state;
}

export default navegaReducer;